import { render, staticRenderFns } from "./UsersConsole.vue?vue&type=template&id=1925b3a7&scoped=true&"
import script from "./UsersConsole.vue?vue&type=script&lang=js&"
export * from "./UsersConsole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1925b3a7",
  null
  
)

export default component.exports